import React from 'react';

import DeepResearchSection from '@components/pages/DeepResearchSection';

import type { DeepResearchBlockProps } from './interfaces';

const DeepResearchBlock = ({ config, content }: DeepResearchBlockProps) => {
  const className = config?.css_classes;

  return (
    <DeepResearchSection
      className={className}
      description={content?.deep_research_description}
      isProSubscriberNotBot={true}
    />
  );
};

export default DeepResearchBlock;
